import CustomerListPage from '.';

export default {
    customerListPage: {
        path: '/customers',
        title: 'Customer',
        auth: true,
        component: CustomerListPage,
        // permission: [apiConfig.news.getList.baseURL],
    },
};
